module.exports = __webpack_public_path__ + "static/fire_giant_king-a525926bf519ffb3ccbc742b34126570.png";